import { render, staticRenderFns } from "./attachmentSection.vue?vue&type=template&id=3d851d88"
import script from "./attachmentSection.vue?vue&type=script&lang=js"
export * from "./attachmentSection.vue?vue&type=script&lang=js"
import style0 from "./attachmentSection.vue?vue&type=style&index=0&id=3d851d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports